import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';

/**
 * @entity KpfFilter
 */
@Entity()
export class FundingpotFundingFilter extends AdornisFilter {
  public static override _class = 'FundingpotFundingFilter';

  constructor(doc: PartialEntityData<FundingpotFundingFilter>) {
    super(doc);
  }

  @Field(() => [String])
  public ids: Maybe<string[]>;

  @Field(() => String)
  public fundingpotID: Maybe<string>;
}
